// extracted by mini-css-extract-plugin
export default {"back_button":"backButton_back_button__G389O"};